import Dialog, {
  DefaultDialogActions,
  DialogBody,
  DialogTitle,
} from '@/components/Dialog';
import { useCompany, useInvestor } from '@/hooks/useStore';
import SearchableDropdown from '@/components/SearchableDropdown';
import Divider from '@/components/Divider';
import Title from '@/components/Title';
import InvestmentsList from './InvestmentsList';
import InvestmentForm from './InvestmentForm';
import { buildCompanyOption, buildInvestorOption, classes } from './utils';

export type EditCompanyInvestorDialogProps = {
  companyId: number;
  investorId: number;
  onClose: () => void;
};

export default function EditCompanyInvestorDialog({
  investorId,
  companyId,
  onClose,
}: EditCompanyInvestorDialogProps) {
  const investor = useInvestor(investorId);
  const company = useCompany(companyId);

  // TODO
  if (!investor || !company) return null;

  const investorOption = buildInvestorOption(investor);
  const companyOption = buildCompanyOption(company);

  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <DialogTitle
        className={classes.dialogTitle}
        title="Edit company investor"
        subtitle="Manage shares & investments"
        onClose={onClose}
      />
      <DialogBody className={classes.body}>
        <div className={classes.leftCol}>
          <Title className={classes.title}>Details</Title>
          <SearchableDropdown
            disabled
            className={classes.dropdown}
            name="company"
            label="Company"
            value={companyOption}
            initialOptions={[]}
            onSearch={async () => []}
            onSelect={() => null}
          />
          <SearchableDropdown
            disabled
            className={classes.dropdown}
            name="investor"
            label="Investor"
            value={investorOption}
            initialOptions={[]}
            onSearch={async () => []}
            onSelect={() => null}
          />
        </div>
        <Divider className={classes.divider} flexItem orientation="vertical" />
        <div className={classes.rightCol}>
          <Title className={classes.title}>Investments</Title>
          <InvestmentForm companyId={companyId} investorId={investorId} />
          <InvestmentsList companyId={companyId} investorId={investorId} />
        </div>
      </DialogBody>
      <DefaultDialogActions
        confirmLabel="Done"
        onConfirm={() => onClose()}
        onCancel={() => onClose()}
      />
    </Dialog>
  );
}
